const list = {
    index: 'index/index',
    addSampleAudio: {
        url: 'referSampleAudio',
        param:{},
    },
};

export default list;